import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CommentService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/comments', query);
  }

  create(body: any) {
    return this.post('/comment', body);
  }

  find(id) {
    return this.get('/comment/' + id);
  }

  update(id, body) {
    return this.put('/comment/' + id, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Comment.service.ts